// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"168":"2b1fa415","373":"15564b8b","443":"29d5acf3","959":"6607a529"}[chunkId] + ".js";
};